var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileKdr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 22C44 34.1503 34.1503 44 22 44C20.1039 44 18.2638 43.7601 16.5085 43.3091L17.5346 41.93L15.7258 43.0924C12.9574 42.2701 10.4172 40.9177 8.2227 39.1529C8.54262 38.3518 9.19914 37.1609 9.79773 36.0752C10.4143 34.9567 10.9695 33.9498 11.0319 33.5953L7.21975 37.1697L7.69682 38.7164C2.98554 34.6814 0 28.6894 0 22C0 9.84974 9.84974 0 22 0C27.0656 0 31.7313 1.71203 35.4501 4.58904L33.864 5.75018L36.1133 5.12288C38.2908 6.94573 40.1103 9.18216 41.4509 11.7113C40.9069 12.2975 40.1952 12.9845 39.5313 13.6254C38.6124 14.5124 37.7852 15.3109 37.6211 15.6313L42.2448 13.3747C43.3747 16.0233 44 18.9386 44 22ZM24.0016 5.75018L24.4713 7.12539L26.3498 4.83337L24.0016 5.75018ZM26.1046 37.8473L26.9587 39.023L24.9851 40.5912L26.1046 37.8473Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7433 14.0835L23.9698 13.381L21.835 9L19.7003 13.381L14.9268 14.0835L18.3809 17.4936L17.5655 22.3088L21.835 20.0354L26.1046 22.3088L25.2892 17.4936L28.7433 14.0835Z",
    fill: "#B2B2B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8358 25.0074L14.1172 21.8711V26.3259L21.8808 29.4806L29.5543 26.3235V21.8711L21.8358 25.0074Z",
    fill: "#B2B2B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8358 30.527L14.1172 27.3906V31.8454L21.8808 35.0001L29.5543 31.8431V27.3906L21.8358 30.527Z",
    fill: "#B2B2B2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileKdr);
export default __webpack_public_path__ + "static/media/profileKDR.7881013658f4150cdce11cca69818343.svg";
export { ForwardRef as ReactComponent };